/**
 * Theme mode storage (ZPL-101). Mirrors the locale helpers in i18n.ts.
 * The pre-paint script in index.html reads the same key — keep the key
 * and semantics in sync with it.
 */

const THEME_MODES = ["light", "dark", "auto"] as const
export type ThemeMode = (typeof THEME_MODES)[number]

const STORAGE_KEY = "zplanem_theme"

export function getStoredThemeMode(): ThemeMode {
	try {
		const stored = localStorage.getItem(STORAGE_KEY)
		if (stored && (THEME_MODES as readonly string[]).includes(stored)) {
			return stored as ThemeMode
		}
	} catch {
		// localStorage unavailable
	}
	return "auto"
}

export function setStoredThemeMode(mode: ThemeMode): void {
	try {
		localStorage.setItem(STORAGE_KEY, mode)
	} catch {
		// localStorage unavailable
	}
}

export function nextThemeMode(mode: ThemeMode): ThemeMode {
	const idx = THEME_MODES.indexOf(mode)
	return THEME_MODES[(idx + 1) % THEME_MODES.length]
}
